import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, Tabs } from 'antd';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { closeAuthDialog, openAuthLoginView, openForgotPasswordView, } from '@/entities/session/model/sessionSlice';
import { ForgotPasswordForm } from '@/features/auth/ui/ForgotPasswordForm';
import { PasswordLoginForm } from '@/features/auth/ui/PasswordLoginForm';
import { SmsLoginForm } from '@/features/auth/ui/SmsLoginForm';
import '@/features/auth/ui/styles/auth-dialog.css';
/** 默认落在验证码登录页签，与历史行为一致。 */
const DEFAULT_TAB_KEY = 'sms';
/** 密码重置成功后落回的页签，方便用户直接用新密码登录。 */
const PASSWORD_TAB_KEY = 'pwd';
/**
 * 渲染全局登录弹窗，不跳转页面，由 Redux 会话状态驱动显隐与视图。
 *
 * 登录与找回密码共用一个弹窗壳：视图存在会话状态里，打开/关闭时由 reducer 复位，
 * 这样两条链路不可能出现两套弹窗样式漂移。
 */
export function AuthDialog() {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector((state) => state.session.isAuthDialogOpen);
    const view = useAppSelector((state) => state.session.authDialogView);
    /** 登录视图当前页签，仅本弹窗内部使用，无需进入全局状态。 */
    const [activeTab, setActiveTab] = useState(DEFAULT_TAB_KEY);
    /**
     * 协议勾选状态，两个登录页签共享。
     *
     * 弹窗带 destroyOnHidden，关闭即卸载，因此下次打开必然回到未勾选态，
     * 满足「每次登录都需重新确认协议」的合规要求，无需额外复位逻辑。
     */
    const [agreementAccepted, setAgreementAccepted] = useState(false);
    /** 密码重置成功后回到登录视图的密码页签，让用户直接用新密码登录。 */
    function handleBackToLogin() {
        setActiveTab(PASSWORD_TAB_KEY);
        dispatch(openAuthLoginView());
    }
    const loginTabs = [
        {
            key: DEFAULT_TAB_KEY,
            label: '验证码登录',
            children: (_jsx(SmsLoginForm, { agreementAccepted: agreementAccepted, onAgreementChange: setAgreementAccepted })),
        },
        {
            key: PASSWORD_TAB_KEY,
            label: '密码登录',
            children: (_jsx(PasswordLoginForm, { agreementAccepted: agreementAccepted, onAgreementChange: setAgreementAccepted, onForgotPassword: () => {
                    dispatch(openForgotPasswordView());
                } })),
        },
    ];
    return (_jsx(Modal, { className: "auth-dialog", rootClassName: "auth-dialog-root", title: view === 'forgot' ? ('找回密码') : (_jsxs("span", { className: "auth-dialog__title", children: [_jsx("img", { className: "auth-dialog__logo", src: "/inyou-logo.svg", alt: "", "aria-hidden": "true" }), "\u767B\u5F55 Inyou"] })), width: 480, centered: true, open: isOpen, footer: null, destroyOnHidden: true, transitionName: "", maskTransitionName: "", onCancel: () => dispatch(closeAuthDialog()), children: view === 'forgot' ? (_jsx(ForgotPasswordForm, { onBackToLogin: handleBackToLogin })) : (_jsx(Tabs, { className: "auth-dialog__tabs", activeKey: activeTab, items: loginTabs, onChange: setActiveTab })) }));
}
